// Calculate user scroll
var newNode = document.createElement('div'),
body = document.getElementsByTagName('body')[0];
newNode.className = 'header-event-scroll';
body.prepend(newNode);
document.getElementsByClassName('header-event-scroll')[0].setAttribute("data-scroll-group", "event-group");
var secElement = document.getElementsByClassName('animate-scroll-section'),
i = 1,
pageName = window.location.href.split('/automate/')[1];
eventScroll = {};
Array.prototype.forEach.call(secElement, function (singleSecElement) {
  singleSecElement.setAttribute("data-event-group", "eventScroll" + i);
  eventScroll["eventScroll" + i] = true;
  i++;
});

function querySelectorArray(query, root){
  return Array.prototype.slice.call((root || document).querySelectorAll(query));
}

var headers = querySelectorArray('[data-scroll-group]');
headers.forEach(function(header){
  var group = header.getAttribute('data-scroll-group');
  sections = querySelectorArray('[data-' + group + ']'),
  window.addEventListener('scroll', function(){
    var lastSection = false;
    sections.forEach(function(section){
      var offset = section.getBoundingClientRect();
      if(offset.top < 0 && offset.top > -offset.height) lastSection = section.getAttribute('data-' + group + '');
    });
    // Apply the class to your header
    header.className = lastSection || '';

    if(eventScroll[lastSection] && lastSection){
      eventScroll[lastSection] = false;
      var locationName = '';
      switch (lastSection) {
        case 'eventScroll1':
          locationName = "HeroUnitSection";
          break;
        case 'eventScroll2':
          locationName = "BrowsersSection";
          break;
        case 'eventScroll3':
          locationName = "GetStartedEasilySection";
          break;
        case 'eventScroll4':
          locationName = "ParallelizationSection";
          break;
        case 'eventScroll5':
          locationName = "FeaturesSection";
          break;
        case 'eventScroll6':
          locationName = "FooterCTASection";
          break;
        case 'eventScroll7':
          locationName = "FAQsSection";
          break;
        default:
          locationName = "AutomateLandingPageSections";
      }

      WebEventTracker.logEvent(EDS.webEvents, "ScrolledOnPage", {
        Page : '/automate/' + pageName,
        Section : locationName
      });
    }
  })
});